/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import { Auth } from 'aws-amplify'
import * as Sentry from '@sentry/browser'
import Textbox from '../Textbox'
import Dropdown from '../Dropdown'
import Button from '../Button'
import Spinner from '../Spinner'
import AuthenticatedAPI from '../../lib/authenticatedAPI'
import InterestButton from './InterestButton'
import Utils from '../../lib/utils'

import FormattedCheckbox from '../FormattedCheckbox'

const INTERESTS = 'Skiing, Running, Crossfit, Climbing, Hiking'

class SignupForm extends React.PureComponent {

  constructor(props) {
    super(props)

    const { userInfo } = props
    if (!userInfo.interests) {
      userInfo.interests = INTERESTS
    }

    this.state = {
      ...userInfo,
      errors: {}
    }
    this.keyCount = 0
    this.getKey = this.getKey.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onChangeByName = this.onChangeByName.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }
    
  onChange(event) {
    this.setState({ [event.target.id]: event.target.value })

    // Validate input fields onChange basis
    this.populateErrors(event.target.id, event.target.value)
  }

  onChangeByName(name, value) {
    this.setState({ [name]: value })

    // Remove validation red borders
    this.setState({
      errors: {
        ...this.state.errors, gender: false
      }
    })
  }

  getKey() {
    this.keyCount += 1
    return this.keyCount
  }

  errorNotice() {
    let { error } = this.state

    // Cognito doesn't seem to throw very elaborate errors
    if (error === 'Username cannot be empty') {
      error = {}
      error.code = 'UsernameEmptyException'
    }

    if (error === 'Password cannot be empty') {
      error = {}
      error.code = 'PasswordEmptyException'
    }

    // Custom
    if (error.message === 'validationError') {
      error = {}
      error.code = 'validationError'
    }

    const determineErrorMsg = () => {
      switch (error.code) {
        case 'UsernameEmptyException':
          return <FormattedMessage id="signup.errorMsg.emailIsRequired" defaultMessage="Email is required" />
        case 'PasswordEmptyException':
          return <FormattedMessage id="signup.errorMsg.passwordIsRequired" defaultMessage="Password is required" />
        case 'UsernameExistsException':
          return <FormattedMessage id="signup.errorMsg.usernameAlreadyExists" defaultMessage="The Email already exists" />
        case 'validationError':
          return <FormattedMessage id="signup.errorMsg.validationError" defaultMessage="Something is missing or the two passwords aren't identical" />
        case 'InvalidParameterException':
          return <FormattedMessage id="signup.errorMsg.invalidParameter" defaultMessage="Your password isn't secure enough. It needs to contain at least 8 characters" />
        case 'InvalidPasswordException':
          return <FormattedMessage id="signup.errorMsg.invalidPassword" defaultMessage="Your password isn't secure enough. It needs to contain at least 8 characters" />
        default:
          return <FormattedMessage id="signup.errorMsg.defaultErrorMsg" defaultMessage="Something went wrong!" />
      }
    }

    return (
      <div className="flex items-center bg-red-lighter text-red text-sm px-4 py-3 mt-6 border-l-4 border-red">
        <div className="py-1">
          <svg className="fill-current h-6 w-6 text-red mr-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z" /></svg>
        </div>
        <div>
          {determineErrorMsg()}
        </div>
      </div>
    )
  }

  // Used to validate inputs, onChange basis
  populateErrors(inputId, inputValue){
    const { password } = this.state
    // populate errors object
    this.setState(prevState => {
      // This is email field, validate it
      if(inputId === 'email') {
        return {
          errors: { ...prevState.errors,
            [inputId]: !Utils.validateEmail(inputValue)
          }
        }
      }

      // This is password field, validate it
      if(inputId === 'password') {
        return {
          errors: { ...prevState.errors,
            [inputId]: (inputValue && inputValue.length > 0) ? false : true
          }
        }
      }

      // This is ConfirmPassword field, validate it
      if(inputId === 'confirmPassword') {
        return {
          errors: { ...prevState.errors,
            [inputId]: (inputValue && inputValue.length > 0 && inputValue === password) ? false : true
          }
        }
      }

      return {
        errors: { ...prevState.errors,
          [inputId]: (inputValue && inputValue.length > 0) ? false : true
      }
    }
    })
    
  }

   // Used to validate inputs, onSubmit
   populateErrorsOnSubmit(){
    const { password, firstName, lastName, gender, country, postalCode, marketing, confirmPassword, email } = this.state
    
    // populate errors object
    this.setState({
        errors: {
          firstName: !(firstName && firstName.length > 0),
          lastName: !(lastName && lastName.length > 0),
          country: !(country && country.length > 0),
          postalCode: !(postalCode && postalCode.length > 0),
          email: !Utils.validateEmail(email),
          password: !(password && password.length > 0),
          confirmPassword: !(confirmPassword && password === confirmPassword),
          marketing: !marketing,
          gender: !gender
     }
    })
    
  }

  async handleSubmit(event) {
    event.preventDefault();
    
    // Validate inputs onSubmit
    this.populateErrorsOnSubmit()
    
    this.setState({ isLoading: true })
    const { props } = this
    const { password, firstName, lastName, birthdayDay, birthdayMonth, birthdayYear, gender, country, postalCode, marketing, facebookId, interests } = this.state
    let { email, dateBirth } = this.state

    
    email = email && email.toLowerCase() // as Cognito accepts distinguishes between caps, and that confuses users

    try {

      if (birthdayDay && birthdayMonth && birthdayYear) {
        const date = new Date(birthdayYear, birthdayMonth - 1, birthdayDay)
        const day = props.intl.formatDate(date, { day: '2-digit' })
        const month = props.intl.formatDate(date, { month: '2-digit' })
        const year = props.intl.formatDate(date, { year: 'numeric' })
        dateBirth = `${year}-${month}-${day}`.replace(/[^ -~]/g, '') // .replace because IE11 was adding '?' when posting dateBirth for some reason (https://stackoverflow.com/questions/44944716/question-mark-within-text-in-ie)
      } else {
        dateBirth = ''
      }

      if (!this.validateForm()) {
        throw new Error("validationError");
      }    
    
      await Auth.signUp({
        username: email,
        password,
        attributes: {
          email
        }
      })
    
      await Auth.signIn(email, password)

      Sentry.configureScope((scope) => {
        scope.setUser({ email })
      })

      try {
        window.Autopilot.run("associate", {
          Email: email,
          FirstName: firstName,
          LastName: lastName
        })
      } catch (error) { /* Do nothing */ }

      await AuthenticatedAPI.put('cphill', '/users', {
        email,
        firstName,
        lastName,
        dateBirth,
        gender,
        country,
        postalCode,
        marketing,
        facebookId,
        interests
      })
      this.setState({ isLoading: false })
      props.afterUserSignup()
    } catch (e) {
      if (e.message && e.message !== 'validationError') {
        Sentry.captureException(e)
      }
      this.setState({ isLoading: false, error: e })
    }
  }

  validateForm() {
    const { email, firstName, lastName, gender, country, postalCode, password, confirmPassword, marketing } = this.state
    return (
      (firstName && firstName.length > 0) &&
      (lastName && lastName.length > 0) &&
      (email && email.length > 0 && Utils.validateEmail(email)) &&
      (gender && gender.length > 0) &&
      (country && country.length > 0) &&
      (postalCode && postalCode.length > 0) &&
      password &&
      password === confirmPassword && 
      marketing
    )
  }  

  monthsOptions() {
    const { props } = this
    const options = []
    for (let i = 0; i <= 11; i += 1) {
      const thisYear = new Date().getFullYear();
      options.push(
        <option key={this.getKey()} value={i + 1}>
          {props.intl.formatDate(new Date(thisYear, i, 1), { month: 'long' })}
        </option>
      )
    }
    return options
  }  

  toggleInterest(interestName) {
    const { interests } = this.state
    const interestArray = interests.split(', ')
    const i = interestArray.indexOf(interestName);
    if (i === -1) {
      interestArray.push(interestName)
    } else {
      interestArray.splice(i, 1)
    }
    this.setState({ interests: interestArray.join(', ') })
  }

  render() {
    const { props, state } = this
    const interestsArray = state.interests.split(', ')

    if (state.isLoading) {
      return <Spinner />
    }

    return (
      <form onSubmit={this.handleSubmit}>        
        <div className="flex flex-wrap md:flex-no-wrap mt-8">
          <div className="w-full md:w-1/2 md:pr-3">
            <label htmlFor="firstName" className="text-sky text-sm font-bold">
              <FormattedMessage id="booking.signup.labelFirstName" defaultMessage="First name" />
              <br />
              <Textbox valid={!state.errors.firstName} htmlId="firstName" htmlName="firstName" type="firstName" value={state.firstName} onChange={this.onChange} className="w-full" />
            </label>
          </div>
          <div className="w-full md:w-1/2 md:pl-3">
            <label htmlFor="lastName" className="text-sky text-sm font-bold">
              <FormattedMessage id="booking.signup.labelLastName" defaultMessage="Last name" />
              <br />
              <Textbox valid={!state.errors.lastName} htmlId="lastName" htmlName="lastName" type="lastName" value={state.lastName} onChange={this.onChange} className="w-full" />
            </label>
          </div>
        </div>
        <div className="flex flex-wrap mt-4">
          <div className="flex md:w-1/2 pr-3">
            <label htmlFor="birthdayDay" className="pr-1 text-sky text-sm font-bold">
              <FormattedMessage id="booking.signup.labelBirthday" defaultMessage="Birthday" />
              <Dropdown htmlId='birthdayDay' htmlName='birthdayDay' value={state.birthdayDay} onChange={this.onChange} className="text-sm text-grey-dark">
                <option>
                  {props.intl.formatMessage({
                  id: 'booking.signup.optionDay',
                  defaultMessage: 'Day'
                })}
                </option>
                {[...Array(31)].map((x, i) => (
                  <option key={this.getKey()}>
                    {i + 1}
                  </option>
                ))}
              </Dropdown>
            </label>
            <label htmlFor="birthdayMonth" className="px-1">
                &nbsp;
              <Dropdown htmlId='birthdayMonth' htmlName='birthdayMonth' value={state.birthdayMonth} onChange={this.onChange} className="flex-grow text-sm text-grey-dark">
                <option value="">
                  {props.intl.formatMessage({
                  id: 'booking.signup.optionMonth',
                  defaultMessage: 'Month'
                })}
                </option>
                {this.monthsOptions()}
              </Dropdown>
            </label>
            <label htmlFor="birthdayYear" className="pl-1">
                &nbsp;
              <Dropdown htmlId='birthdayYear' htmlName='birthdayYear' value={state.birthdayYear} onChange={this.onChange} className="text-sm text-grey-dark">
                <option>
                  {props.intl.formatMessage({
                  id: 'booking.signup.optionYear',
                  defaultMessage: 'Year'
                })}
                </option>
                {[...Array(150)].map((x, i) => (
                  <option key={this.getKey()}>
                    {new Date().getFullYear() - (i + 1)}
                  </option>
                  ))}
              </Dropdown>
            </label>
          </div>
          <div className="md:w-1/2 pl-3">
            <div className="text-sky text-sm font-bold">
              <FormattedMessage id="booking.signup.labelGender" defaultMessage="Gender" />
            </div>
            <div className="inline-flex">
              <button id="gender" name="gender" type="button" onClick={() => this.onChangeByName('gender', 'male')} className={`${state.gender === 'male' ? 'text-harbor' : 'text-grey-dark'} flex text-left mt-3 focus:outline-none`}>
                <div className={`custom-radio flex rounded-full border ${this.state.errors.gender && 'border-red bg-red-lightest'} w-6 h-6 mr-2 items-center justify-center`}>
                  {state.gender === 'male' && <div className="rounded-full bg-harbor w-3 h-3" />}
                </div>
                  
                <div>
                  <FormattedMessage id="booking.signup.labelMale" defaultMessage="Male" />
                </div>
              </button>
  
              <button id="gender" name="gender" type="button" onClick={() => this.onChangeByName('gender', 'female')} value="female" className={`${state.gender === 'female' ? 'text-harbor' : 'text-grey-dark'} flex text-left mt-3 ml-6 focus:outline-none`}>
              <div className={`custom-radio flex rounded-full border ${this.state.errors.gender && 'border-red bg-red-lightest'} w-6 h-6 mr-2 items-center justify-center`}>
                  {state.gender === 'female'
                    && <div className="rounded-full bg-harbor w-3 h-3" />}
                </div>
                <div>
                  <FormattedMessage id="booking.signup.labelFemale" defaultMessage="Female" />
                </div>
              </button>
            </div>
          </div>
        </div>
  
        <div className="flex md:w-1/2 pr-3 mt-4">
          <label htmlFor="country" className="text-sky text-sm font-bold pr-2">
            <FormattedMessage id="booking.signup.labelCountry" defaultMessage="Country" />
            <Textbox valid={!state.errors.country} htmlId="country" htmlName="country" value={state.country} onChange={this.onChange} placeholder="E.g. DK" placeholderI18n="booking.signup.placeholderCountry" className="w-full" />
          </label>
          <label htmlFor="postalCode" className="text-sky text-sm font-bold pl-2">
            <FormattedMessage id="booking.signup.labelPostalCode" defaultMessage="Zip code" />
            <Textbox valid={!state.errors.postalCode} htmlId="postalCode" htmlName="postalCode" value={state.postalCode} onChange={this.onChange} placeholder="E.g. 2860" placeholderI18n="booking.signup.placeholderPostalCode" className="w-full" />
          </label>
        </div>
  
        <div className="md:w-1/2 pr-3 mt-4">          
          <label htmlFor="email" className="text-sky text-sm font-bold">
            <FormattedMessage id="booking.signup.labelEmail" defaultMessage="E-mail" />
            <br />
            <Textbox valid={!state.errors.email} htmlId="email" htmlName="email" type="email" value={state.email || ""} onChange={this.onChange} placeholder="E.g. you@email.com" placeholderI18n="booking.signup.placeholderEmail" className="w-full" />
          </label>
        </div>
  
        <div className="flex mt-4">
          <div className="md:w-1/2 pr-3">
            <label htmlFor="password" className="text-sky text-sm font-bold">
              <FormattedMessage id="booking.signup.labelPassword" defaultMessage="Password" />
              <br />
              <Textbox valid={!state.errors.password} htmlId="password" htmlName="password" value={state.password} onChange={this.onChange} type="password" className="w-full" />
            </label>
          </div>         
          <div className="md:w-1/2 md:pl-3">
            <label htmlFor="confirmPassword" className="text-sky text-sm font-bold">
              <FormattedMessage id="booking.signup.labelConfirmPassword" defaultMessage="Confirm Password" />
              <br />
              <Textbox valid={!state.errors.confirmPassword} htmlId="confirmPassword" htmlName="confirmPassword" value={state.confirmPassword} onChange={this.onChange} type="password" className="w-full" />
            </label>
          </div>
        </div>

        <div className="mt-4 text-sky text-sm font-bold">
          <FormattedMessage id="booking.signup.labelInterests" defaultMessage="Interests" />
        </div>

        {INTERESTS.split(', ').map(interestValue => (
          <InterestButton
            key={this.getKey()}
            onClick={() => { this.toggleInterest(interestValue) }} 
            interestName={props.intl.formatMessage({ id: `signup.interests.${interestValue.toLowerCase()}` })}
            checked={interestsArray.includes(interestValue)}
          />
        ))}

        {/* <button
          onClick={() => { this.setState({ acceptTerms: !state.acceptTerms }) }}
          className="flex items-center mt-4 text-md cursor-pointer mt-8"
          type="button"
        >
          <div className="w-8">
            <FormattedCheckbox checked={state.acceptTerms} />
          </div>
          <label htmlFor="acceptTerms" className="font-bold cursor-pointer">
            <FormattedMessage id="signup.acceptTerms.label" defaultMessage="YES" />
          </label>
        </button>
        <div className="ml-8">
          <FormattedMessage
            id="signup.acceptTerms.description" 
            values={{
              link: (
                <a
                  href={props.intl.formatMessage({ id: 'signup.acceptTerms.url' })}
                  target='_blank'
                  rel="noopener noreferrer"
                  className="underline text-harbor"
                >
                  {props.intl.formatMessage({ id: 'signup.acceptTerms.linkText' })}
                </a>
              )
            }}
            defaultMessage="[translate]"
          />
        </div> */}

        <button
          onClick={() => { this.setState({ marketing: !state.marketing, errors: {...this.state.errors, marketing: !state.errors.marketing} }) }}
          className="flex items-center mt-12 text-md cursor-pointer focus:outline-none"
          type="button"
        >
          <div className="w-8">
            <FormattedCheckbox checked={state.marketing} valid={!this.state.errors.marketing} />
          </div>
          <label htmlFor="newsletter" className="font-bold cursor-pointer">
            <FormattedMessage id="signup.marketing.label" defaultMessage="YES" />
          </label>
        </button>
        <div className="ml-8">
          <FormattedMessage id="signup.marketing.description" defaultMessage="[Translate]" />
        </div>
        <div className="text-sm mt-4 ml-8">
          <p>
            <FormattedMessage
              id="signup.marketing.policy.paragraph1"
              values={{
                link: (
                  <a
                    href={props.intl.formatMessage({ id: 'signup.marketing.policy.paragraph1.linkUrl' })}
                    target='_blank'
                    rel="noopener noreferrer"
                    className="underline text-harbor"
                  >
                    {props.intl.formatMessage({ id: 'signup.marketing.policy.paragraph1.linkText' })}
                  </a>
                )
              }}
              defaultMessage="[Translate]"
            />
          </p>
          <p>
            <FormattedMessage id="signup.marketing.policy.paragraph2" defaultMessage="[Translate]" />
          </p>
          <p>
            <FormattedMessage
              id="signup.marketing.policy.paragraph3"
              values={{
                link: (
                  <a
                    href={props.intl.formatMessage({ id: 'signup.marketing.policy.paragraph3.linkUrl' })}
                    target='_blank'
                    rel="noopener noreferrer"
                    className="underline text-harbor"
                  >
                    {props.intl.formatMessage({ id: 'signup.marketing.policy.paragraph3.linkText' })}
                  </a>
                )
              }}
              defaultMessage="[Translate]"
            />
          </p>
        </div>

        {state.error && this.errorNotice()}
  
        <div className="flex flex-row justify-end mt-8">
          <div className="flex-grow">
            {props.backAction && (
              <Button
                type="button"
                onClick={props.backAction}
                bgCss="bg-grey"
                className="text-harbor"
              >
                <FormattedMessage id="booking.signup.buttonBack" defaultMessage="Back" />
              </Button>
            )}
          </div>
          <Button className={`${this.validateForm() ? '' : 'opacity-50 cursor-not-allowed'}`}>
            <FormattedMessage id="booking.signup.buttonContinue" defaultMessage="Sign up" />
          </Button>
        </div>
      </form>
    )
  }
}

SignupForm.propTypes = {
  userInfo: PropTypes.shape({
    email: PropTypes.string,
    password: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    gender: PropTypes.string,
    country: PropTypes.string,
    postalCode: PropTypes.string,
    confirmPassword: PropTypes.string,
    dateBirth: PropTypes.string,
    interests: PropTypes.string
  }),
  backAction: PropTypes.func
}

SignupForm.defaultProps = {
  userInfo: {
    email: "",
    interests: INTERESTS
  },
  backAction: null
}

export default injectIntl(SignupForm)